// Webpack Imports
import * as bootstrap from 'bootstrap';

(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});

	let singulae = document.querySelectorAll('mark.sigulae');
	singulae.forEach((singula) => {
		singula.setAttribute('data-bs-title', "<p><b>Qu’est-ce qu’un Singula&nbsp;?</b><br/><span>C’est quelqu’un qui a été profilé par Mental’O&nbsp;!</span></p> <p>Chaque personne est unique et le Bilan de Profilage permet de la révéler dans toute sa singularité. Elle n’est donc pas un «&nbsp;candidat&nbsp;», un «&nbsp;contact&nbsp;», un «&nbsp;collaborateur&nbsp;» … encore moins une «&nbsp;observation statistique&nbsp;» mais un <b>Singula</b> (au pluriel des <b>Singulae</b>)</p>");
	});

	const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
	const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))



	let items = document.querySelectorAll('.carousel .carousel-item')
	items.forEach((el) => {
		const minPerSlide = 3;
		let next = el.nextElementSibling;
		console.log({ el, next });
		for (var i = 1; i < minPerSlide; i++) {
			console.log({ i, next });
			if (!next || !next.classList.contains('carousel-item')) {
				// wrap carousel by using first child
				next = items[0];
			}
			let cloneChild = next.cloneNode(true)
			console.log({ cloneChild });
			el.appendChild(cloneChild.children[0])
			next = next.nextElementSibling
		}
	});


})();
